import { createApiCall } from 'lib/base';

const FETCH_NHSV_WEBHOOK_CONFIG_DETAIL = 'FETCH_NHSV_WEBHOOK_CONFIG_DETAIL';

const apiCall = createApiCall(
  FETCH_NHSV_WEBHOOK_CONFIG_DETAIL,
  ({ id }: { id: string }) => ({
    endpoint: `api/admin/nhsv/webhook/configs/${id}`,
    method: 'GET',
  })
);

export default apiCall;
